import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {User} from "../../shared/api/users/api.models";
import {AuthenticationService} from "../../shared/authentication.service";
import {ModalService} from "../../shared/modal.service";
import {UserModal} from "./components/user.modal";
import {Role} from "../../shared/api/roles/api.models";
import {Company} from "../../shared/api/companies/api.models";
import {Api} from "../../shared/api.service";
import {Utils} from "../../shared/utils.service";
import {Me} from "../../shared/api/me/me.models";
import {Language} from "../../shared/api/languages/api.models";

@Component({
    selector: 'settings-users',
    template: require('./users.component.html'),
    styles: [require('./users.component.scss')]
})

export class SettingsUsersComponent implements OnInit {
    protected me: Me;
    protected myUserId: number;

    protected users: User[];
    protected usersHash: any = {};
    protected roles: Role[];
    protected rolesHash: any = {};
    protected companies: Company[];
    protected companyHash: any = {};
    protected languages: Language[];

    protected filter: any = {
        user: null,
        role: null,
        company: null
    };

    constructor(
        private route: ActivatedRoute,
        private api: Api,
        private auth: AuthenticationService,
        private modal: ModalService,
        private utils: Utils
    ) {}

    ngOnInit() {
        this.me        = this.auth.getMe();
        this.myUserId  = this.auth.getUserId();
        this.users     = this.route.snapshot.data['users'];
        this.roles     = this.route.snapshot.data['roles'];
        this.companies = this.route.snapshot.data['companies'];
        this.languages = this.route.snapshot.data['languages'];

        // Do some nice sorting for the user
        this.utils.sortList(this.languages, 'label');
        this.utils.sortList(this.users, 'username');
        this.utils.sortList(this.roles, 'name');

        // Hash the object
        this.utils.hash(this.usersHash, this.users);
        this.utils.hash(this.rolesHash, this.roles);

        if (this.companies.length > 0) {
            this.utils.sortList(this.companies, 'name');
            this.utils.hash(this.companyHash, this.companies);
        }
    }

    new() {
        let user = new User();
        if (this.roles.length === 1) {
            user.roleId = this.roles[0].id;
        }

        if (this.companies.length === 0) {
            user.companyId = this.me.companyId;
        } else if (this.companies.length === 1) {
            user.companyId = this.companies[0].id;
        }

        this.openModal(user).then(
            (user: User) => {
                this.users.push(user);
                this.utils.sortList(this.users, 'username');
            },
            () => {}
        );
    }

    change(user: User) {
        this.openModal(Object.assign({}, user)).then(
            (newUser: User) => {
                Object.assign(user, newUser);

                if (newUser.id === this.me.id) {
                    this.auth.reloadMe().subscribe((me: Me) => {
                        this.me = me;
                    });
                }
            },
            () => {}
        );
    }

    remove(user: User) {

        this.modal.confirm(
            'Remove user',
            'Are you sure to remove ' + user.username + '?'
        ).then(
            () => {
                this.api.users().remove(user.id).subscribe(() => {
                    this.users.splice(this.users.indexOf(user), 1);
                });
            },
            () => {

            }
        );
    }

    private openModal(user: User): Promise<any> {
        let modal = this.modal.custom(UserModal);

        modal.componentInstance.me        = this.me;
        modal.componentInstance.myUserId  = this.myUserId;
        modal.componentInstance.users     = this.users;
        modal.componentInstance.user      = user;
        modal.componentInstance.roles     = this.roles;
        modal.componentInstance.companies = this.companies;
        modal.componentInstance.languages = this.languages;

        return modal.result;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/users/users.component.ts